module.exports = __webpack_public_path__ + "img/image2.0e55c2a4.png";